// extracted by mini-css-extract-plugin
export default {"modalWrapper":"modal_modalWrapper__e15Wv","inside":"modal_inside__LNL8h"};